module.exports = __webpack_public_path__ + "static/btc-meditation-b4e4043372fa345c4df31537203a941f.png";